import React from 'react'
import { useState, useEffect } from 'react';
import { useData } from '../contexts/DataContext'

const Footer = () => {

  const { lastUpdatedDate } = useData();
  const [year, getYear] = useState(null);
  const [month, getMonth] = useState(null);
  const [day, getDay] = useState(null);

  useEffect(() => {
    if (lastUpdatedDate) {
      // Firestore Timestamp 객체 또는 Date 객체인 경우 처리
      const date = lastUpdatedDate.toDate ? lastUpdatedDate.toDate() : new Date(lastUpdatedDate);
      
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // JavaScript의 월은 0부터 시작
      const day = date.getDate();

      getYear(year);
      getMonth(month);
      getDay(day);
      
    }
  }, [lastUpdatedDate]);

  return (
    <footer>
      <div className="footer_area">
        <div className="logo_area">
          <div className="toolkit_logo">
            <img src={`${process.env.PUBLIC_URL}/img/logo_toolkit_white.png`} alt="" />
          </div>
          <div className="jogakbo_logo">
            <img  src={`${process.env.PUBLIC_URL}/img/logo_jogakbo_long.png`}
                  className='jogakbo'
                  alt="트랜스젠더 인권단체 조각보 로고" />
          </div>
        </div>
        <div className="desc">
          <a className="homepage" target='_blank' rel="noreferrer" href='https://www.transgender.or.kr/'>트랜스젠더 인권단체 조각보 홈페이지 바로가기</a>
          <p className="account">후원 계좌: 우리은행 1005-004-560225<br />예금주 명:  트랜스젠더 인권단체 조각보</p>
          <time className="date" dateTime="2025-05-05">최종 수정: {`${year}`}년 {`${month}`}월 {`${day}`}일</time>
        </div>
      </div>
    </footer>
  )
}

export default Footer
